import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import BreadcrumbDmwf from '../components/BreadcrumbDmwf'
import DmwfComponent from '../components/Dmwfcomponent'
import DmwfSection from '../components/DmwfSection'
import DmwfSection2 from '../components/DmwfSection2'

export default function DmwfEvent() {
  return (
    <div>
      <Header1/>
      <BreadcrumbDmwf/>
      <DmwfComponent/>
      <DmwfSection/>
      <DmwfSection2/>
      <Footer/>
    </div>
  )
}
